import {Injectable, Inject, Component} from 'ng-metadata/core';
import {getInstitutionCode, getVid, getSyndetixWithProxy} from '../../../appConfig/appConfigForward';
import {ImagesUtil} from "../../../nddUtils/ImagesUtil.service";
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";
import {PrimoExploreFooterService} from "../../../primoExplore/primoExploreFooter.service";
import {reflect} from "../../../infra/promiseReflect";
import {getResouceTypeImages} from '../../../appConfig/customizationConfig';
import {STATE_NAMES} from '../../../primoExplore/primoExploreStates.module';
import { VirtualBrowseItem } from '../../virtualBrowse/virtualBrowse.service';
import { WindowInfoUtils } from '../../../../components/nddUtils/windowInfoUtils.service';


const _get = require('lodash/get');
const _union = require('lodash/union');
const _isObject = require('lodash/isObject');

@Injectable()

export class SearchResultThumbnailContainerService {

    constructor(private imagesUtil: ImagesUtil,
                private configurationUtil: ConfigurationUtil,
                private primoExploreFooterService: PrimoExploreFooterService,
                private windowInfoUtils : WindowInfoUtils,
                @Inject('$http') private $http: ng.IHttpService,
                @Inject('$q') private $q: ng.IQService,
                @Inject('$state') private $state: angular.ui.IStateService,
                @Inject('restBaseURLs') private restBaseURLs) {
    }

    getThumbnailLinks(links, isFeaturedResult, frbr, isFrbrGeneric, item, isVirtualBrowse, virtualBrowseItem, pnxId) {

         return this.$q((resolve, reject)=> {

            let thumbnailLinks = [];
            let linksArray = links || [];
            //let item: PrimoResponse.IDoc = this.item;

            let type = this.getType(isFeaturedResult, item);

            let externalThumbnail = '';

            this.defineDefaultTumbnail(type, frbr, isFrbrGeneric, isFeaturedResult, isVirtualBrowse, item).then((defaultThumbnail) => {
                if (isFeaturedResult) {
                    thumbnailLinks = linksArray;
                }
                else {
                    thumbnailLinks = thumbnailLinks.concat(
                        linksArray.filter((e) => {
                            return e.displayLabel === 'thumbnail';
                        }));
                }
                if (!(frbr && isFrbrGeneric) || this.isPcRecord(item)) {
                    this.getThumbnailFromAlmaD(item, isVirtualBrowse, virtualBrowseItem, isFeaturedResult, pnxId).then((link)=> {
                        if (link) {
                            resolve(link);
                        } else {
                               this.getThumbnailFromOther(thumbnailLinks).then((link) => {
                               if (link) {
                               resolve(link);
                                }
                            else {
                            this.getThumbnailFromSyndeticsEXL(thumbnailLinks, item).then((link) => {
                                if (link) {
                                    resolve(link);
                                }
                                else {
                                    this.getThumbnailFromSyndetics(thumbnailLinks).then((link) => {
                                        if (link) {
                                            resolve(link);
                                        }
                               				 else {
                                                    this.getThumbnailFromGoogle(thumbnailLinks, item).then((link) => {
                                                        if (link) {
                                                            resolve(link);
                                                        } else {
                                                            _isObject(defaultThumbnail) && (defaultThumbnail['isDefault'] = true);
                                                            resolve(defaultThumbnail);
                                                        }
                                                    });
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
                else {
                    defaultThumbnail['isDefault'] = true;
                    resolve(defaultThumbnail);
                }
            });
        });
    }

    public getType(isFeaturedResult, item) {
        if (isFeaturedResult) {
            return 'book'
        }
        else {
            return item && item.pnx.display.type ? item.pnx.display.type[0] : []
        }
    }

    private defineDefaultTumbnail(type, frbr, isFrbrGeneric, isFeaturedResult, isVirtualBrowse, item) {

        if (frbr && isFrbrGeneric && !this.isPc(item) && !this.isFavoriteState()) {
            type = 'versions';
        }

        let undefinedThumbnail = {
            displayLabel: 'thumbnail',
            linkType: 'http://purl.org/pnx/linkType/thumbnail',
            linkURL: getResouceTypeImages()['other'] || 'img/icon_other.png'
        };

        let defaultThumbnail = {
            displayLabel: 'thumbnail',
            linkType: 'http://purl.org/pnx/linkType/thumbnail',
            linkURL: type.length > 0 ? 'img/icon_' + type + '.png' : undefined
        };

        let customThumbnail = {
            displayLabel: 'thumbnail',
            linkType: 'http://purl.org/pnx/linkType/thumbnail',
            linkURL: getResouceTypeImages()[type]
        };


        return this.$q((resolve) => {
            if (isFeaturedResult) {
                resolve('');
            }
            let defaultThumbnailLink = defaultThumbnail;
            this.imagesUtil.getImageLink(customThumbnail).then(
                (link) => {
                    resolve(customThumbnail);
                }, (link) => {
                    this.imagesUtil.getImageLink(defaultThumbnail).then(
                        (link) => {
                            resolve(defaultThumbnail);
                        }, (link) => {
                            if (!isVirtualBrowse) {
                                resolve(undefinedThumbnail);
                            } else {
                                resolve('');
                            }
                        })
                });
        });
    }

    private isFrbr(isFeaturedResult, frbr) {
        if (isFeaturedResult) {
            return false;
        }
        else {
            return frbr;
        }
    }

    private isPcRecord(item) {
        let recordId = _get(item, 'pnx.control.recordid[0]');
        let context = _get(item, 'context');
        let adaptor = _get(item, 'adaptor');
        return context === 'PC' || (recordId && recordId.startsWith('TN_')) || adaptor === 'Primo Central';
    }

    /**
     * @param item The PNX item (if this is from a pnx request)
     * @param isVirtualBrowse If the request is from virtual browse
     * @param virtualBrowseItem The virtual browse item
     */
    private getThumbnailFromAlmaD(item, isVirtualBrowse, virtualBrowseItem, isFeaturedResult, pnxId) {
        return this.$q(async (resolve) => {
            let thumbnailLink = '';
            if(isFeaturedResult && pnxId) {
                thumbnailLink = this.getAlmaDigitalThumbnailForFeaturedResult(pnxId);
            }
            else if (isVirtualBrowse) {
                thumbnailLink = this.getAlmaDigitalThumbnailForVirtualBrowse(virtualBrowseItem);
            }
            else if(this.isAlmaD(item) || _get(item, 'pnx.control.isDedup')) {
                thumbnailLink = await this.getAlmaDigitalThumbnailForPnx(item);
            }
            this.resolveAlmaDigitalImage(thumbnailLink).then((link) => { 
                resolve(link);
            }, () => {
                resolve('');
            });
        });
    }

    private getAlmaDigitalThumbnailForFeaturedResult(pnxId) {
        pnxId = pnxId.replace(/^alma/,"");  // Remove 'alma' from id
        return this.getAlmaDigitalThumbnailUrl(pnxId) + '?ignoreDefault=true';
    }
  
    private getAlmaDigitalThumbnailForVirtualBrowse(virtualBrowseItem){
        let thumbnailLink = '';
        if(_get(virtualBrowseItem, 'hasD')){
            let mmsId = _get(virtualBrowseItem, 'recordId');
            if(mmsId){
                mmsId = mmsId.substr(4); // Remove 'alma' from the link
                thumbnailLink = this.getAlmaDigitalThumbnailUrl(mmsId) + '?ignoreDefault=true';
            }
        }
        return thumbnailLink;
    }

    private async getAlmaDigitalThumbnailForPnx(item) : Promise<string> {
        let mms_id = _get(item, 'pnx.control.sourcerecordid[0]');
        let institutionCode = _get(item, 'delivery.recordInstitutionCode');
        let thumbnailUrl = this.getAlmaDigitalThumbnailUrl(mms_id, institutionCode);
        // For shared D - find the correct link to the thumbnail
        if(_get(item, 'delivery.sharedDigitalCandidates') && item.delivery.sharedDigitalCandidates.length > 0){
            let response = await this.$http.post(this.restBaseURLs.getThumbnail + '/' + institutionCode + '/' + mms_id + '?vid=' + getVid() , _get(item, 'delivery.sharedDigitalCandidates'));
            thumbnailUrl = response.data as string;
        } else if (_get(item, 'pnx.control.isDedup')){
            try {
                let response = await this.$http.get(this.restBaseURLs.getThumbnail + '/' + mms_id + '?vid=' + getVid());
            } catch (error) { return ''; }
            if(!_get(response, 'data.hasDigitalInventory')){
                return '';
            }
        }
        thumbnailUrl = thumbnailUrl + '?ignoreDefault=true';
        if (this.isEsploroRecord(item)) {
            thumbnailUrl = thumbnailUrl + '&calculateAccessRights=true';
        }
        return thumbnailUrl;
    }

    private getAlmaDigitalThumbnailUrl(mmsId, institutionCode?){
        if (!institutionCode) {
            institutionCode = getInstitutionCode();
        }
        return "/view/delivery/thumbnail/" + institutionCode + "/" + mmsId;
    }

    private resolveAlmaDigitalImage(thumbnailUrl){
        return this.imagesUtil.getImageLink(this.createLinkObj(thumbnailUrl));
    }

    private getThumbnailFromSyndeticsEXL(thumbnailLinks, item) {
        return this.$q((resolve) => {
            let useSyndetics = false;
            let syndeticsLinks = [];

            syndeticsLinks = thumbnailLinks.filter(this.getSpecificLink, 'syndetics.com').filter(this.getSpecificLink, 'primo');
            if (syndeticsLinks.length > 0) {
                useSyndetics = true;
            }
            if (this.configurationUtil.isSuprima()) {
                //create syndetics thumbnails
                let isbns = _get(item, 'pnx.addata.isbn', []);
                let eisbns = _get(item, 'pnx.addata.eisbn', []);
                isbns = _union(isbns, eisbns);
                let issns = _get(item, 'pnx.addata.issn', []);
                let eissns = _get(item, 'pnx.addata.eissn', []);
                issns = _union(issns, eissns);
                let upc = _get(item, 'pnx.addata.upcid', []);
                let syntetixBaseUrl = "https://syndetics.com/index.php?client=primo&";
         if (isbns && isbns.length > 0) {
                    for (let i = 0; i < isbns.length; i++) {
                        syndeticsLinks.push(this.createLinkObj(syntetixBaseUrl + "isbn=" + isbns[i] +  (this.windowInfoUtils.isMobile() ? '/sc.jpg' : '/lc.jpg')));
                    }
                    useSyndetics = true;
                }
                if (issns && issns.length > 0) {
                    for (let i = 0; i < issns.length; i++) {
                        syndeticsLinks.push(this.createLinkObj(syntetixBaseUrl + "issn=" + issns[i] +(this.windowInfoUtils.isMobile() ? '/sc.jpg' : '/lc.jpg')));
                    }
                    useSyndetics = true;
                }
                if (upc && upc.length > 0) {
                    for (let i = 0; i < upc.length; i++) {
                        syndeticsLinks.push(this.createLinkObj(syntetixBaseUrl + "upc=" + upc[i] + (this.windowInfoUtils.isMobile() ? '/sc.jpg' : '/lc.jpg')));
                    }
                    useSyndetics = true;
                }
            }



            if (useSyndetics) {
                this.handleSyndeticsThumbnailLinks(syndeticsLinks, resolve);
            } else {
                resolve('');
            }
        });
    }



    private getThumbnailFromSyndetics(thumbnailLinks) {
        return this.$q((resolve) => {
            let useSyndetics = false;
            let syndeticsLinks = [];

            syndeticsLinks = thumbnailLinks.filter(this.getSpecificLink, 'syndetics.com');
            if (syndeticsLinks.length > 0) {
                useSyndetics = true;
            }
            if (useSyndetics) {
                this.handleSyndeticsThumbnailLinks(syndeticsLinks, resolve);
            } else {
                resolve('');
            }
        });
    }

    private handleSyndeticsThumbnailLinks(syndeticsLinks, resolve){
        let promiseArray = [];
        let syndeticsProxy = getSyndetixWithProxy();
        for (let i = 0; i < syndeticsLinks.length; i++) {
            let link = syndeticsLinks[i];
            link.linkURL = link.linkURL.replace('https://syndetics.com/index.php?client=', syndeticsProxy);
            promiseArray.push(this.imagesUtil.getImageLink(link));
        }
        this.createPromiseOnlyFailOnAllFailedResolveFirstSuccess(promiseArray, resolve);
    }


    private hasReliableIdentifierForGoogle(item): boolean {
        let isbns = _get(item, 'pnx.addata.isbn', []);
        let eisbns = _get(item, 'pnx.addata.eisbn', []);
        let lccns = _get(item, 'pnx.addata.lccn', []);
        return (isbns && isbns.length > 0) || (eisbns && eisbns.length > 0) || (lccns && lccns.length > 0);
    }

    private getThumbnailFromGoogle(thumbnailLinks, item?) {
        return this.$q((resolve) => {
            if (item && !this.hasReliableIdentifierForGoogle(item)) {
                resolve('');
                return;
            }
        	if(!this.primoExploreFooterService.showICPLicenseFooter){
	            let googleLink = thumbnailLinks.filter(this.getSpecificLink, 'books.google.com');
	            if (angular.isDefined(googleLink) && googleLink.length > 0) {
	                let linkUrl = googleLink[0].linkURL;
                    if (typeof linkUrl != 'string') {
                        linkUrl = googleLink[0].linkURL.linkURL;
                    }
                linkUrl = linkUrl.replace(/\s+/g, '');
	                let gbUrl = linkUrl.replace('&callback=updateGBSCover', '');
	                this.$http.jsonp(gbUrl).then((data) => {
	                    let res = data.data;
	                    let keys = Object.keys(res);
	                    if (keys.length > 0) {
	                        let thumbnailUrl = res[keys[0]].thumbnail_url;
	                        if (angular.isDefined(thumbnailUrl)) {
	                            let returnedLink = {
	                                displayLabel: 'thumbnail',
	                                linkType: 'http://purl.org/pnx/linkType/thumbnail',
	                                linkURL: this.imagesUtil.handleLink(thumbnailUrl)
	                            };
	
	                            resolve(returnedLink);
	                        } else {
	                            resolve('');
	                        }
	                    } else {
	                        resolve('');
	                    }
	                }, () => resolve(''));
	            } else {
	                resolve('');
	            }
	        } else {
	                resolve('');
	        }
        });
    }

    private getThumbnailFromOther(thumbnailLinks) {
        return this.$q((resolve) => {
            let otherThumbnailLinks = thumbnailLinks.filter(this.getAllButSpecificLink, 'amazon');
            otherThumbnailLinks = otherThumbnailLinks.filter(this.getAllButSpecificLink, 'syndetics.com');
            otherThumbnailLinks = otherThumbnailLinks.filter(this.getAllButSpecificLink, 'google.com');

            if (otherThumbnailLinks.length) {
                let promiseArray = [];
                for (let i = 0; i < otherThumbnailLinks.length; i++) {
                    this.removeLabelFromLinkUrl(otherThumbnailLinks[i]);
                    promiseArray.push(this.imagesUtil.getImageLink(otherThumbnailLinks[i]));
                }
                this.createPromiseOnlyFailOnAllFailedResolveFirstSuccess(promiseArray, resolve);
            } else {
                resolve('');
            }
        });
    }

    private removeLabelFromLinkUrl(thumbnailLink){
        let linkUrl = thumbnailLink.linkURL;
        if(linkUrl && linkUrl.includes('$$L')){
            thumbnailLink.linkURL = linkUrl.substr(0, linkUrl.indexOf('$$L')).trim();
        }
    }

    private isAlmaD(item) {
        if (!this.configurationUtil.isSuprima()) {
            return false;
        }
        if (item.context === 'SP' && _get(item, 'pnx.control.sourceid') === 'alma' && item.delivery.electronicServices) {
            return (item.delivery.electronicServices.filter(
                (svc)=> svc.serviceType === 'DIGITAL').length > 0);
        } else {
            let deliveryThumbnail = _get(item, 'thumbnailForCD.hasD');
            return (deliveryThumbnail === true) ||
                item.delivery['hasD'] === true || item.delivery['digitalAuxiliaryMode'] === true || item.delivery['digitalAuxiliaryThumbnail'] === true;
        }
    }

    private createLinkObj(url) {
        return {
            displayLabel: 'thumbnail',
            linkType: 'http://purl.org/pnx/linkType/thumbnail',
            linkURL: url
        };
    }

    public getSpecificLink(thumbnailLink) {
        let linkIdentifier = this;
        if (typeof thumbnailLink === 'string') {//todo change
            return thumbnailLink.indexOf(linkIdentifier) > -1;
        }
        let linkURL = _get(thumbnailLink, 'linkURL');
        if(!linkURL) {
            return false;
        }
        if (typeof linkURL === 'string') {//todo change
            return linkURL.indexOf(linkIdentifier) > -1;
        }
        return linkURL.linkURL.indexOf(linkIdentifier) > -1;
    }

    private getAllButSpecificLink(thumbnailLink) {
        let linkIdentifier = this;
        if (typeof thumbnailLink === 'string') {//todo change
            return thumbnailLink.indexOf(linkIdentifier) === -1
        }
        let linkURL = _get(thumbnailLink, 'linkURL');
        if(!linkURL) {
            return false;
        }
        if (typeof linkURL === 'string') {//todo change
            return linkURL.indexOf(linkIdentifier) === -1;
        }
        return linkURL.linkURL.indexOf(linkIdentifier) === -1;
    }

    isPc(item) {
        return item.context === 'PC';
    }

    isFavoriteState() {
        if (this.$state.is(STATE_NAMES.FAVORITES)) {
            return true;
        }
        return false;
    }

    public createPromiseOnlyFailOnAllFailedResolveFirstSuccess(promiseArray, resolve){
        this.$q.all(promiseArray.map(reflect)).then((results)=> {
            let successfulResults = results.filter((result)=> result.status === 'resolved');
            if (successfulResults.length) {
                resolve(successfulResults[0].value);
            }
            else {
                resolve('');
            }
        });
    }

	private isEsploroRecord(item) {
	    if (item && 
    		item.pnx && 
    		item.pnx.control && 
    		item.pnx.control.sourceformat &&
    		item.pnx.control.sourceformat.length > 0 &&  
    		item.pnx.control.sourceformat[0] === 'ESPLORO') {

    			return true;
		}
		
		return false;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultThumbnail/searchResultThumbnailContainer.service.ts